<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg-img" src="./images/bg.png" alt="" />
      <span class="balance">{{ Math.floor(crystalBalance / 1) }}</span>
      <!-- <span class="lottery-count">{{ lotteryCount }}</span> -->

      <div class="tab-box">
        <img
          class="tab-one"
          src="./images/tab-one-active.png"
          alt=""
          v-show="tab === 1"
          @click="selectDrawNumber(1)"
        />
        <img
          class="tab-one"
          src="./images/tab-one.png"
          alt=""
          v-show="tab === 2"
          @click="selectDrawNumber(1)"
        />
        <img
          class="tab-ten"
          src="./images/tab-ten-active.png"
          v-show="tab === 2"
          alt=""
          @click="selectDrawNumber(2)"
        />
        <img
          class="tab-ten"
          src="./images/tab-ten.png"
          alt=""
          v-show="tab === 1"
          @click="selectDrawNumber(2)"
        />
      </div>
      <div class="lucky-draw-box">
        <LuckyGrid
          ref="luckyDraw"
          :width="luckyDrawConfig.width"
          :height="luckyDrawConfig.height"
          :prizes="luckyDrawConfig.prizes"
          :rows="luckyDrawConfig.rows"
          :cols="luckyDrawConfig.cols"
          :blocks="luckyDrawConfig.blocks"
          :buttons="luckyDrawConfig.buttons"
          :speed="luckyDrawConfig.speed"
          :active-style="luckyDrawConfig.activeStyle"
          @start="handleStart"
          @end="endLuckDraw"
        />
      </div>
    </div>
    <!-- <el-dialog
      title=""
      :visible.sync="countDialog"
      width="346px"
      top="30vh"
      append-to-body
      :show-close="false"
      custom-class="candies-draw8-dialog"
    >
      <div class="el-message-box fps-message-box   two-btn">
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message">
              <p>
                你想用
                <input type="text" v-model="drawNumber" @input="handleInput" />
                顆糖果交換禮物嗎
              </p>
            </div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button
            type="button"
            class="el-button el-button--default el-button--small"
            @click="countDialog = false"
          >
            <span>
              取消
            </span></button
          ><button
            type="button"
            class="el-button el-button--default el-button--small el-button--primary "
            @click="handleSubmit"
          >
            <span>
              確定
            </span>
          </button>
        </div>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Login from '@/components/Login/index';

export default {
  name: 'ActivityPage',
  data() {
    return {
      activityData: {},
      crystalBalance: 0, // 糖果數量
      costNumber: 500, //單次抽獎需要花費
      drawLoading: false,
      // countDialog: false,
      lotteryCount: 0, // 抽獎次數
      prizeList: [
        //九宮格的第一位 index=0
        {
          code: 'P01',
          name: '月下蝶影（1天）'
        },
        {
          code: 'P05',
          name: '黃金寶箱'
        },
        {
          code: 'P06',
          name: '66會員積分'
        },
        {
          code: 'P02',
          name: '月下蝶影（3天）'
        },
        {
          code: 'P08',
          name: '88鑽石'
        },

        {
          code: 'P04',
          name: '白銀寶箱(*2)'
        },
        {
          code: 'P07',
          name: '66鑽石'
        },
        {
          code: 'P03',
          name: '白銀寶箱'
        }
      ],
      drawNumber: 1, //抽獎次數
      drawResult: [], //抽獎結果
      isTest: false, //  是否測試模式
      emptyCode: 'P09', //為謝謝惠顧時的代碼
      errorResponse: {},
      tab: 1,
      isFinished: new Date().getTime() > new Date(2024, 9, 14)
    };
  },
  computed: {
    ...mapGetters(['accountInfo', 'userInfo']),
    //轉盤設置
    luckyDrawConfig() {
      return {
        width: '580',
        height: '590',
        rows: 3,
        cols: 3,
        blocks: [
          {
            // padding: '40px 20px 50px 50px'
            // imgs: [
            //   {
            //     src: require('@/activities/candies-draw10/images/draw-bg.png'),
            //     width: '100%',
            //     height: '100%'
            //   }
            // ]
          }
        ],
        prizes: [
          {
            x: 0,
            y: 0,
            imgs: [
              {
                src: require('@/activities/candies-draw10/images/1.png'),
                width: '190px',
                height: '190px',
                activeSrc: require('@/activities/candies-draw10/images/active1.png')
              }
            ]
          },
          {
            x: 1,
            y: 0,
            imgs: [
              {
                src: require('@/activities/candies-draw10/images/2.png'),
                width: '190px',
                height: '190px',
                activeSrc: require('@/activities/candies-draw10/images/active2.png')
              }
            ]
          },
          {
            x: 2,
            y: 0,
            imgs: [
              {
                src: require('@/activities/candies-draw10/images/3.png'),
                width: '190px',
                height: '190px',
                activeSrc: require('@/activities/candies-draw10/images/active3.png')
              }
            ]
          },
          {
            x: 2,
            y: 1,
            imgs: [
              {
                src: require('@/activities/candies-draw10/images/4.png'),
                width: '190px',
                height: '190px',
                activeSrc: require('@/activities/candies-draw10/images/active4.png')
              }
            ]
          },
          {
            x: 2,
            y: 2,
            imgs: [
              {
                src: require('@/activities/candies-draw10/images/5.png'),
                width: '190px',
                height: '190px',
                activeSrc: require('@/activities/candies-draw10/images/active5.png')
              }
            ]
          },
          {
            x: 1,
            y: 2,
            imgs: [
              {
                src: require('@/activities/candies-draw10/images/6.png'),
                width: '190px',
                height: '190px',
                activeSrc: require('@/activities/candies-draw10/images/active6.png')
              }
            ]
          },
          {
            x: 0,
            y: 2,
            imgs: [
              {
                src: require('@/activities/candies-draw10/images/7.png'),
                width: '190px',
                height: '190px',
                activeSrc: require('@/activities/candies-draw10/images/active7.png')
              }
            ]
          },
          {
            x: 0,
            y: 1,
            imgs: [
              {
                src: require('@/activities/candies-draw10/images/8.png'),
                width: '190px',
                height: '190px',
                activeSrc: require('@/activities/candies-draw10/images/active8.png')
              }
            ]
          }
        ],
        activeStyle: {
          background: 'transparent'
        },
        buttons: [
          {
            x: 1,
            y: 1,
            imgs: [
              {
                src: this.drawLoading
                  ? require('@/activities/candies-draw10/images/button.png')
                  : require('@/activities/candies-draw10/images/button.png'),
                width: '190px',
                height: '190px'
              }
            ]
          }
        ]
      };
    }
  },
  methods: {
    // 活動結束提醒
    showFinishedDialog() {
      if (this.isFinished || this.activityData.status == 'finished') {
        this.$confirm({
          content:
            '當前活動已結束，更多福利敬請留意nicee平臺，感謝您的支援呀～',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickModal: false
        }).then(() => {
          // this.$router.push({ path: '/' });
        });
      }
    },
    // 獲取詳情
    async getDetail() {
      try {
        let data = {};
        if (this.isTest) {
          data = {
            crystalBalance: 5000
          };
        } else {
          const result = await this.$http.get(
            '/activity/getActivityLotteryInfo',
            {
              dictType: 'lotteryConf'
            }
          );
          data = result.data;
        }
        this.crystalBalance = data.crystalBalance || 0;
        this.activityData = data || {};
        this.showFinishedDialog();
      } catch (error) {
        console.log(error);
      }
    },
    // 檢查登入
    checkLogin() {
      return new Promise(resolve => {
        if (!this.userInfo) {
          Login();
          return;
        } else {
          resolve();
        }
      });
    },
    async handleStart() {
      if (!this.isTest) {
        if (this.isFinished || this.activityData.status == 'finished') {
          this.showFinishedDialog();
          return;
        }
        if (this.drawLoading) return;
        await this.checkLogin();
      }
      this.showDrawNumberDialog();
      // if (this.tab === 1) {
      //   this.showDrawNumberDialog();
      // } else {
      //   this.countDialog = true;
      // }
    },
    showDrawNumberDialog() {
      this.$confirm({
        content: `當前糖果${Math.floor(this.crystalBalance / 1)},抽獎需${this
          .drawNumber * this.costNumber}顆糖果`,
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        closeOnClickOverlay: false
      })
        .then(() => {
          this.startLuckDraw();
        })
        .catch(() => {});
    },
    // 點選抽獎按鈕會觸發start回調
    async startLuckDraw() {
      if (this.crystalBalance >= this.costNumber * this.drawNumber) {
        this.getDrawResult();
      } else {
        this.$confirm({
          title: '糖果不足',
          content: `當前糖果${Math.floor(this.crystalBalance / 1)},抽獎需${this
            .drawNumber * this.costNumber}顆糖果`,
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true
        });
      }
    },
    // 獲取抽獎結果
    async getDrawResult() {
      this.$refs.luckyDraw.play();
      this.drawLoading = true;
      this.drawResult = [];
      try {
        let data = '[]';
        await new Promise(resolve => setTimeout(resolve, 2000));
        if (this.isTest) {
          data =
            '[{"name":"P08","count":1},{"name":"P07","count":3},{"name":"P06","count":1},{"name":"P05","count":3}]';
          // data = '[{"name":"P02","count":1}]';
        } else {
          const result = await this.$http.get('/activity/lottery', {
            dictType: 'lotteryConf',
            count: this.drawNumber
          });
          data = result.data;
        }
        if (data) {
          this.drawResult = JSON.parse(data) || [];
          this.crystalBalance =
            this.crystalBalance - this.costNumber * this.drawNumber;
          if (!this.isTest) {
            this.getDetail();
            this.getLotteryCount();
          }
          this.stopDraw();
        }
      } catch (error) {
        this.errorResponse = error;
        if (error && error.msg) {
          this.$message(error.msg);
        }
        this.$refs.luckyDraw.stop(0);
        this.drawLoading = false;
      }
    },
    stopDraw() {
      const drawCode =
        this.drawNumber === 1
          ? this.drawResult[0].name
          : this.drawResult[this.drawResult.length - 1].name;
      const drawIndex = this.prizeList.findIndex(item => {
        return item.code == drawCode;
      });
      console.log(drawIndex);
      // 調用stop停止旋轉並傳遞中獎索引
      this.$refs.luckyDraw.stop(drawIndex);
      this.drawLoading = false;
    },
    endLuckDraw() {
      let drawName = '';
      if (
        this.drawResult.length === 0 ||
        (this.drawResult.length === 1 &&
          this.drawResult[0].name === this.emptyCode)
      ) {
        this.$confirm({
          content: `祝你好運`,
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          dangerouslyUseHTMLString: true
        });
      } else {
        this.drawResult.forEach(item => {
          const prize = this.prizeList.find(prize => {
            return prize.code == item.name;
          });
          if (prize) {
            if (prize.code !== this.emptyCode) {
              drawName = `${drawName}${prize.name}*${1 * item.count}<br />`;
            }
          }
        });
        drawName = drawName.slice(0, -1);
        this.$confirm({
          content: `
          ${drawName}
          `,
          title: '恭喜你抽中了',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          dangerouslyUseHTMLString: true
        });
      }
      this.$refs.luckyDraw.init();
    },
    selectDrawNumber(drawNumber) {
      if (drawNumber === 1) {
        this.drawNumber = drawNumber;
        this.handleStart();
        this.tab = 1;
      } else {
        this.drawNumber = 10;
        this.handleStart();
        // this.countDialog = true;
        this.tab = 2;
      }
    },
    handleSubmit() {
      // this.countDialog = false;
      this.startLuckDraw();
    },
    handleInput(event) {
      // 過濾非數字字符
      this.inputNicee = event.target.value.replace(/\D/g, '');
    },
    async getLotteryCount() {
      const { data } = await this.$http.get('/activity/lotteryCount');
      this.lotteryCount = data || 0;
    }
  },
  created() {
    this.getDetail();
    this.getLotteryCount();
  }
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background: url('./images/bg2.jpg') no-repeat;
  background-size: cover;
  overflow: auto;
  text-align: center;
  .main {
    position: relative;
    display: inline-block;
    width: 750px;
    text-align: left;
    > .bg-img {
      width: 100%;
    }
    .avatar-frame,
    .avatar-frame2 {
      position: absolute;
      top: 1054px;
      left: 198px;
      width: 260px;
      height: auto;
    }
    .avatar-frame2 {
      top: 1424px;
      left: 184px;
      width: 267px;
    }
    .balance {
      position: absolute;
      top: 2378px;
      right: 92px;
      text-align: center;
      font-size: 54px;
      color: #971212;
      width: 286px;
      height: 75px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .lottery-count {
      position: absolute;
      font-size: 70px;
      color: #2c7e51;
      top: 3340px;
      left: 58%;
      text-align: center;
      color: white;
      text-shadow: 2px 2px 4px #8a4fbb;
    }
    .lucky-draw-box {
      position: absolute;
      top: 3054px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
    }
    .tab-box {
      position: absolute;
      top: 2850px;
      left: 0;
      height: 174px;
      width: 485px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .tab-one,
    .tab-ten {
      width: 194px;
    }
    .icon {
      position: absolute;
      bottom: 82px;
      right: 0;
      z-index: 2;
    }
  }
}
/deep/ .candies-draw8-dialog {
  background: inherit;
  box-shadow: none;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    input {
      border-bottom: 1px solid #efefef;
      text-align: center;
      height: 40px;
      width: 50px !important;
    }
  }
  .el-dialog__footer {
    display: none;
  }
}
</style>
